import React, { useState, useEffect } from "react";
import "../../styles/Home.css";
import Header from "../../components/Layout/Header.tsx";
import FilterSection, {
  defaultFilter,
  FilterFormType,
} from "../../components/Layout/FilterSection.tsx";
import CenterSpinner from "../../components/UI/CenterSpinner.tsx";
import {
  ACTIVE_VIEW_CONSOLIDATED,
  ACTIVE_VIEW_COUNTRY,
  ACTIVE_VIEW_STATE,
  MAP_VIEW,
} from "../../utils/Constants.tsx";
import { useDispatch, useSelector } from "react-redux";
import StateMap from "./StateMap.tsx";
import ConsolidatedView from "./ConsolidatedView.tsx";

const Home = () => {
  const [selectedFilters, setSelectedFilters] =
    useState<FilterFormType>(defaultFilter);
  const [gridId, setGridId] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [distanceRange, setDistanceRange] = useState(0);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedRow,setSelectedRow] =useState(null)
  const activeView = useSelector((state: any) => state?.filter?.activeView);
  
  return (
    <>
      <Header />
      <div className="main-container">
        <FilterSection
          onApplyFilters={(filterData) => {
            if (filterData.state == "country")
              filterData.mapView = filterData.mapView
                ? filterData.mapView
                : MAP_VIEW.GRID_WISE;
            setSelectedFilters(filterData);
            if (!filterData.distance) {
              setDistanceRange(0);
            }
          }}
          onClearGridId={() => {
            setGridId(null);
          }}
          gridId={gridId}
          onDistanceRangeChange={setDistanceRange}
          selectedRow={selectedRow}
          onStateChange={setSelectedState}
        />
       {activeView === ACTIVE_VIEW_CONSOLIDATED && <ConsolidatedView selectedFilters={selectedFilters} setSelectedRow={setSelectedRow}></ConsolidatedView>} 
        {activeView === ACTIVE_VIEW_STATE && (
          <StateMap
            selectedFilters={selectedFilters}
            setGridId={setGridId}
            gridId={gridId}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            distanceRange={distanceRange}
            stateFilter={selectedState}
          />
        )}
        {(activeView === ACTIVE_VIEW_COUNTRY ||
          selectedFilters.state === "country") && (
          <StateMap
            selectedFilters={selectedFilters}
            setGridId={setGridId}
            gridId={gridId}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            distanceRange={distanceRange}
            stateFilter={selectedState}
          />
        )}
        {/* <div className={(activeView === ACTIVE_VIEW_COUNTRY || selectedFilters.state=== 'country') ? "show" : "hide"}>
         
        </div> */}
      </div>
      <CenterSpinner showLoader={isLoading} />
    </>
  );
};

export default Home;
